import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';

import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations';
import Flight from '../entities/flight';
import FlightSearchResponse from '../entities/flight/flightSearchResponse';

interface FlightState extends ListState<Flight> {
  select: Flight;
}

class FlightMutations extends ListMutations<Flight> {}

class FlightModule extends ListModule<FlightState, any, Flight> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<Flight>(),
    flightSearchResponses: new Array<FlightSearchResponse>(),
    loading: false,
  };
  actions = {
    async searchFlight(context: ActionContext<FlightState, any>, payload: any) {
      context.state.loading = true;
      let response = await Ajax.post(
        '/api/services/app/Flight/SaveFlightSearch',
        payload.data
      );

      context.state.loading = false;
      let result = response.data.result.id;

      return result;
      // context.state.totalCount=page.totalCount;
      // context.state.list=page.items;
    },
    async getFlightSearchResults(
      context: ActionContext<FlightState, any>,
      payload: any
    ) {
      context.state.loading = true;
      let response = await Ajax.get(
        '/api/services/app/Flight/GetFlightSearchResults',
        { params: { Id: payload.data } }
      );
      context.state.loading = false;
      context.state.list = response.data.result.flightSearchResponses;
      return response;
      // context.state.totalCount=page.totalCount;
      // context.state.list=page.items;
    },
  };
  mutations = {
    setCurrentPage(state: FlightState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: FlightState, pagesize: number) {
      state.pageSize = pagesize;
    },
  };
}
const flightModule = new FlightModule();
export default flightModule;
